/**
 * Name-related utility functions
 */

/**
 * Extracts initials from a person's name
 * @param name - The full name (e.g., "John Doe" or "Alice")
 * @returns Initials string (e.g., "JD" for "John Doe", "A" for "Alice")
 */
export function getInitials(name: string): string {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
